import { render, staticRenderFns } from "./CompetitionView.vue?vue&type=template&id=65047732&scoped=true"
import script from "./CompetitionView.vue?vue&type=script&lang=ts"
export * from "./CompetitionView.vue?vue&type=script&lang=ts"
import style0 from "./CompetitionView.vue?vue&type=style&index=0&id=65047732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65047732",
  null
  
)

export default component.exports